import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'

interface UpdateCashierInput {
  id: string
  name: string
  email: string | null
  role: 'staff' | 'manager'
  status: 'active' | 'inactive'
}

async function updateCashier(input: UpdateCashierInput): Promise<void> {
  const { error } = await supabase
    .from('cashier_pins')
    .update({ name: input.name, email: input.email, role: input.role, status: input.status })
    .eq('id', input.id)
  if (error) {
    reportUnexpectedError(error)
    throw error
  }
}

export function useUpdateCashier() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateCashier,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['cashiers'] }),
  })
}